import { render, staticRenderFns } from "./UiChip.vue?vue&type=template&id=498a8605"
import script from "./UiChip.vue?vue&type=script&lang=ts"
export * from "./UiChip.vue?vue&type=script&lang=ts"
import style0 from "./UiChip.vue?vue&type=style&index=0&id=498a8605&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports